<template>
  <div>
    <!-- only show div if there's a title to be shown, otherwise it will eat up space -->
    <div
      class="overview-card-layout__title--mobile"
      v-if="title && isMobileScreen"
    >
      {{ title }}
    </div>
    <a-card class="overview-card-layout" v-bind="$attrs" :bordered="false">
      <template #title>
        <!-- Title Header -->
        <div class="overview-card-layout__header">
          <slot name="left-title-element"></slot>
          <slot name="title">{{ title }}</slot>
        </div>
      </template>

      <template #extra>
        <slot name="extra"></slot>
      </template>

      <template #actions>
        <div
          v-if="$slots['left-actions']"
          class="overview-card-layout__footer-actions--left"
        >
          <slot name="left-actions"></slot>
        </div>

        <div
          v-if="$slots['right-actions']"
          class="overview-card-layout__footer-actions--right"
        >
          <slot name="right-actions"></slot>
        </div>
      </template>
      <slot></slot>
    </a-card>
  </div>
</template>

<style lang="scss">
// Padding for desktop should be 40px, and smaller screens to 20px
.overview-card-layout {
  margin: $margin-lg $margin-xlg;
  border: 1px solid $separator-color;
  background: $card-background;
  border-radius: $overview-card-border-radius;

  &__header {
    display: flex;
    align-items: center;
  }
  .ant-card-head-title {
    padding: $overview-card-padding-header-title 0px !important;
    margin-top: $margin-xss !important;
  }
  .ant-card-body {
    padding: $overview-card-padding; //20px
  }

  .ant-card-extra {
    padding: unset;

    button {
      font-size: $btn-font-size;
      font-weight: $font-regular;
      padding: unset;
    }
  }

  // Footer background
  .ant-card-actions {
    background: $card-background;
    border-bottom-left-radius: $overview-card-border-radius;
    border-bottom-right-radius: $overview-card-border-radius;
  }

  &__footer-actions {
    &--left {
      text-align: left;
      // Offset padding from button
      padding-left: $padding-lg;

      button {
        font-size: $btn-font-size;
        font-weight: $font-regular;
        letter-spacing: 0.7px;
        padding: 0 5px;
        text-transform: uppercase;
      }
    }
    &--right {
      text-align: right;
      // Offset padding from button
      padding-right: $padding-lg;

      button {
        font-size: $btn-font-size;
        font-weight: $font-regular;
        letter-spacing: 0.7px;
        padding: 0 5px;
      }
    }
  }

  // Use negative margins and paddings to cancel out parent ant-card-body padding
  .generic-transfer-summary__amount-wrapper,
  .transfer-summary__amount-details {
    margin-left: -$margin-common-lg; // 20px
    margin-right: -$margin-common-lg;
    margin-bottom: -$margin-common-lg;
    padding: $overview-card-padding;
    border-bottom-left-radius: $overview-card-border-radius;
    border-bottom-right-radius: $overview-card-border-radius;
  }

  &__title--mobile {
    font-size: $overview-card-mobile-header-font-size;
    margin: $overview-card-mobile-header-margin;

    // Hide on larger screens
    @media screen and (min-width: $screen-md) {
      display: none;
    }
  }

  // IPAD, mobile screens and below
  @media screen and (max-width: $screen-lg) {
    margin: #{$card-layout-spacing-laptop}px;
    .ant-card-body {
      padding: $overview-card-padding; //20px
    }

    .generic-transfer-summary__amount-wrapper,
    .transfer-summary__amount-details {
      margin-left: 4px - $padding-lg;
      margin-right: 4px - $padding-lg;
      margin-bottom: 4px - $padding-lg;
      padding: $padding-lg - 4px;
    }
  }

  @media screen and (max-width: $screen-sm) {
    margin: $margin-xs;

    .generic-transfer-summary__amount-wrapper,
    .transfer-summary__amount-details {
      margin-left: -$margin-sm;
      margin-right: -$margin-sm;
      margin-bottom: -$margin-sm;
      padding: $padding-sm;
    }

    .ant-card-head {
      display: none !important;
      padding: 0 $padding-md;
      border-bottom: none;
      color: $text-color;
    }

    .ant-card-body {
      padding: $padding-sm;
    }

    .ant-card-actions {
      border-top: 2px solid $body-background;
    }

    .ant-card-actions > li:not(:last-child) {
      border: none !important;
    }

    // Set cursor-pointer to all HeaderTitle in mobile (used in mobile back button)
    .header-title__title {
      cursor: pointer;
    }
  }
}
</style>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { windowSizeSimpleStore } from "@/shared/store/simpleStore/windowSizeData";

export default defineComponent({
  setup() {
    return {
      isMobileScreen: computed(() => windowSizeSimpleStore.isMobile),
    };
  },
  props: {
    title: String,
  },
});
</script>
